import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { ThemeConstantService } from './services/theme-constant.service';
import { NgZorroAntdModule } from '../ng-zorro-antd.module';
import { MsalInterceptor } from '@azure/msal-angular';
import { HttpLoadingInterceptor } from './interceptor/http-loading.interceptor';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { EditGuardDirective } from './directives/edit-guard.directive';
import { DeleteGuardDirective } from './directives/delete-guard.directive';
import { TerminateGuardDirective } from './directives/termiate-guard.directive';
@NgModule({
    exports: [
        CommonModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgZorroAntdModule,
        ReactiveFormsModule,
        FormsModule,
        EditGuardDirective,
        DeleteGuardDirective,
        TerminateGuardDirective
    ],
    imports: [
        CommonModule,
        NgZorroAntdModule,
        FormsModule

    ],
    declarations: [
    
    EditGuardDirective,
    DeleteGuardDirective,
    TerminateGuardDirective
  ],
    providers: [
     ThemeConstantService,
     {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpLoadingInterceptor,
        multi: true
      },
      { provide: ErrorHandler, useClass: GlobalErrorHandlerService}
    ],
    
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})

export class SharedModule { 
   
}
